var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxReverseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16992 7.43994L11.9999 12.5499L20.7699 7.46991",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.61V12.54",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6096 12.83V9.17C21.6096 7.79 20.6196 6.11002 19.4096 5.44002L14.0696 2.48C12.9296 1.84 11.0696 1.84 9.92963 2.48L4.58963 5.44002C3.37963 6.11002 2.38965 7.79 2.38965 9.17V14.83C2.38965 16.21 3.37963 17.89 4.58963 18.56L9.92963 21.52C10.4996 21.84 11.2496 22 11.9996 22C12.7496 22 13.4996 21.84 14.0696 21.52",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 18C23.25 20.07 21.57 21.75 19.5 21.75C17.43 21.75 16.1662 19.665 16.1662 19.665M16.1662 19.665H17.8613M16.1662 19.665V21.54M15.75 18C15.75 15.93 17.415 14.25 19.5 14.25C22.0013 14.25 23.25 16.335 23.25 16.335M23.25 16.335V14.46M23.25 16.335H21.585",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxReverseIcon);
export default __webpack_public_path__ + "static/media/box-reverse-icon.0d2fda114c1c96966d636443d1d303bc.svg";
export { ForwardRef as ReactComponent };